import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgDialogModule } from '@principle-theorem/ng-shared';
import {
  IAccInvoice,
  IAccInvoiceFundingRequest,
} from '@principle-theorem/principle-core/interfaces';
import { DATE_WITH_YEAR, WithRef } from '@principle-theorem/shared';
import { FUNDING_REQUEST_STATUS_CLASS_MAP } from '../acc-view-claim-dialog/acc-view-claim-dialog.component';
import { sum } from 'lodash';

export interface IAccViewInvoiceDialogData {
  invoiceRequest: WithRef<IAccInvoiceFundingRequest>;
  accInvoice: IAccInvoice;
}

@Component({
  selector: 'pr-acc-view-invoice-dialog',
  imports: [NgDialogModule],
  templateUrl: './acc-view-invoice-dialog.component.html',
  styleUrl: './acc-view-invoice-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccViewInvoiceDialogComponent {
  data = inject<IAccViewInvoiceDialogData>(MAT_DIALOG_DATA);
  dateFormat = DATE_WITH_YEAR;
  serviceCodes = this._getServiceCodes();
  invoiceAmount = this._getInvoiceAmount();

  get statusClasses(): string {
    return FUNDING_REQUEST_STATUS_CLASS_MAP[this.data.invoiceRequest.status];
  }

  private _getServiceCodes(): string {
    return this.data.accInvoice.lines
      .flatMap((line) => line.lineDetails?.serviceCodes ?? [])
      .flat()
      .join(', ');
  }

  private _getInvoiceAmount(): number {
    return sum(
      this.data.accInvoice.lines
        .flatMap((line) => line.lineDetails?.invoiceAmount ?? 0)
        .flat()
    );
  }
}
